import {useCookieConsent} from '../contexts/CookieConsentContext';

const CookieConsentBanner = () => {
    const {isBannerVisible, acceptConsent, rejectConsent} = useCookieConsent();

    if (!isBannerVisible) {
        return null;
    }

    return (
        <div className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-pink-200 shadow-lg">
            <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row items-center gap-4">
                <p className="text-sm text-gray-700 flex-1">
                    Wir verwenden Cookies, um die Wirksamkeit unserer Werbung zu messen. Weitere
                    Informationen findest du in unserer{' '}
                    <a
                        href={`${process.env.REACT_APP_BASE_SITE_URL}/datenschutzerklaerung`}
                        className="text-pegasusPurple underline"
                    >
                        Datenschutzerklärung
                    </a>.
                </p>
                <div className="flex gap-2 shrink-0">
                    <button
                        onClick={rejectConsent}
                        className="py-2 px-4 rounded-lg font-semibold bg-gray-200 text-gray-800 hover:bg-gray-300"
                    >
                        Ablehnen
                    </button>
                    <button
                        onClick={acceptConsent}
                        className="py-2 px-4 rounded-lg font-semibold bg-pegasusPurple text-white hover:bg-pegasusPurpleHover"
                    >
                        Akzeptieren
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsentBanner;
